export default __webpack_public_path__ + "static/media/274.30e7b009.jpg";